import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const AttendanceFeature: FeatureMetadata = {
  id: "attendance",
  moduleName: "academics",
  guardianNavigation: {
    order: 3,
  },

  navigation: {
    label: "Attendance",
    path: "/attendance",
    icon: CalendarDaysIcon,
    order: 3,
  },

  route: {
    path: "/attendance",
    element: lazy(() => import("./pages/Attendance")),
  },

  permissions: {
    view: "Academics.Attendance.view",
    create: "Academics.Attendance.create",
    edit: "Academics.Attendance.edit",
    delete: "Academics.Attendance.delete",
  },

  readiness: "live",
};
